import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import '../../../css/CreateAdditionalAddress.css';
import Vas from '../../../Vas';
import { ExtendedButton,DateField,MessageBox,TextField, SelectField,EmailField,ConfirmBox,AutocompleteField } from 'component-lib';
import { TranslateGender,DateTimeHelper, CheckValues } from 'utils-lib';
import { RequestAjaxClass, AdditionalAddressesModel,CustomerModel,StreetsModel,GenderModel } from 'models-lib';


var moment = require('moment');
moment().format();

class CreateAdditionalAddress extends Component
{
    constructor(props){
        super(props);
        this.state = {};
        this.CustomerId = props.match.params.CustomerId;
        this.state.CustomerText = '';
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request3 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);

        this.AdditionalAddressesModel = new AdditionalAddressesModel([this],null,this.Request);
        this.StreetsModel = new StreetsModel([this],null,this.Request3);
        this.CustomerModel = new CustomerModel([this],null,this.Request2);

        this.ConfigSelectableAdditionalAddresses = Vas.Config.AdditionalAddresses;

        // eslint-disable-next-line no-unused-expressions
        //this.Request2 = new RequestAjaxClass((error)=>{this.props.ErrorHandling ? this.props.ErrorHandling(error) : '';},null);
        this.GenderModel = new GenderModel([this], null, this.Request2);

        this.Request2.setAuth(false);
        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setApiUrl(Vas.ApiUrl);

        this.GenderModel.GetGender();
    }

    componentDidMount(){
      
      this.Request.setAuth(true);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);

      this.Request3.setAuth(true);
      this.Request3.setApiKey(Vas.ApiKey);
      this.Request3.setApiUrl(Vas.ApiUrl);
      
      let me = this;
      
      /*this.Request.setErrorHandler(()=>{
        me.setState({ requiredFields:[me.refs.name,me.refs.firstName,me.refs.dateOfBirth,me.refs.zip, me.refs.city,me.refs.street,me.refs.houseNumber],
          requiredSelectField : [me.refs.gender,me.refs.addressTypes,me.refs.salutation],
          AddressID:0 },()=>{
              for (let i=0; i<me.state.requiredFields.length; i++){
                  if (me.state.requiredFields[i].props.IsRequired){
                    me.state.requiredFields[i].setState({ Label:me.state.requiredFields[i].props.Label+"*" });
                  }
              }

              for (let i = 0; i < me.state.requiredSelectField.length; i++){
                if (me.state.requiredSelectField[i].props.IsRequired){
                  me.state.requiredSelectField[i].setState({ Label:me.state.requiredSelectField[i].props.Label + "*" });
                }
              }
          }); 
      })*/
      this.AdditionalAddressesModel.GetAdditionalAddressTypes();

      if (localStorage.getItem('vas_role') !== '1'){
        this.CustomerModel.GetCustomerById(this.CustomerId);
        
      }

      me.setState({ requiredFields:[me.refs.name,me.refs.firstName,me.refs.zip, me.refs.city,me.refs.street,me.refs.houseNumber,me.refs.dateOfBirth],
        requiredSelectField : [me.refs.gender]},()=>{
            for (let i=0; i<me.state.requiredFields.length; i++){
                if (me.state.requiredFields[i].props.IsRequired){
                  me.state.requiredFields[i].setState({ Label:me.state.requiredFields[i].props.Label+"*" });
                }
            }
            for (let i=0; i<this.state.requiredSelectField.length; i++){
              if (this.state.requiredSelectField[i].props.IsRequired){
                  this.state.requiredSelectField[i].setState({ Label:this.state.requiredSelectField[i].props.Label+"*" });
              }
          }
        }
      );

      this.LogoClick();

      this.FontSizeClick();
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "AddressTypes"){
          let AddressID = 0;
          let data = me.AdditionalAddressesModel.AddressTypes;
          let addresses = [];
          if (data){

                  for (let i = 0; i< data.length; i++){
                    let value = data[i];

                    //Anschrift Erziehungsberechtigter 1
                    if(value.Id === 11 && this.ConfigSelectableAdditionalAddresses.Erziehungsberechtigter1) {
                      let adress ={Key:value.Id, Display:Vas.Resources.Labels["Erz1"]};
                      addresses.push(adress);

                      continue;
                    }

                    //Anschrift Erziehungsberechtigter 2
                    if(value.Id === 12 && this.ConfigSelectableAdditionalAddresses.Erziehungsberechtigter2) {
                      let adress ={Key:value.Id, Display:Vas.Resources.Labels["Erz2"]};
                      addresses.push(adress);

                      continue;
                    }

                    //Rechnungsanschrift
                    if(value.Id === 21 && this.ConfigSelectableAdditionalAddresses.Rechnungsanschrift) {                    
                      let adress ={Key:value.Id, Display:value.Name};
                      addresses.push(adress);

                      continue;
                    }

                    //Lieferanschrift
                    if(value.Id === 22 && this.ConfigSelectableAdditionalAddresses.Lieferanschrift) {
                      let adress ={Key:value.Id, Display:value.Name};
                      addresses.push(adress);

                      continue;
                    }

                    //Firmenanschrift
                    if(value.Id === 27 && this.ConfigSelectableAdditionalAddresses.Firma) {
                      let adress ={Key:value.Id, Display:value.Name};
                      addresses.push(adress);

                      continue;
                    }
                    
                    //Anschrift des Kontoinhabers
                    if(value.Id === 52 && this.ConfigSelectableAdditionalAddresses.Kontoinhaber) {
                      let adress ={Key:value.Id, Display:value.Name};
                      addresses.push(adress);

                      continue;
                    }
                  }
              
          }

          me.refs.addressTypes.setState({Data:addresses});
          me.setState({ requiredFields:[me.refs.name,me.refs.firstName,me.refs.zip, me.refs.city,me.refs.street,me.refs.houseNumber],
            requiredSelectField : [me.refs.addressTypes],
            AddressID:AddressID },()=>{
              
                for (let i=0; i<me.state.requiredFields.length; i++){
                    if (me.state.requiredFields[i].props.IsRequired){
                      me.state.requiredFields[i].setState({ Label:me.state.requiredFields[i].props.Label+"*" });
                    }
                }

                for (let i = 0; i < me.state.requiredSelectField.length; i++){
                  if (me.state.requiredSelectField[i].props.IsRequired){
                    me.state.requiredSelectField[i].setState({ Label:me.state.requiredSelectField[i].props.Label + "*" });
                  }
                }
            }
          ); 
        }
        else if(observer === "Customer"){
          let data = me.CustomerModel.Customer;

          if (data.Data && data.Data.length > 0)
          {
              let value = data.Data[0];

              me.setState({ CustomerText: <table style={{ textAlign: "justify" }}>
                <thead>
                  <tr>
                    <th colSpan={2}>{Vas.Resources.Labels["AddressesFor"]}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["CustomerNumber"]}:
                    </td>
                    <td>
                      {value.CustomerNumber}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["Name"]}:
                    </td>
                    <td>
                      {value.Name1}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["FirstName"]}:
                    </td>
                    <td>
                      {value.Name2}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["Email"]}:
                    </td>
                    <td>
                      {value.Email}
                    </td>
                  </tr>
                </tbody>
              </table>
            });
          }
        }
        else if(observer === "NewAdditionalAddress"){
          Vas.GetView('CreateAdditionalAddressSuccess', { CustomerId : me.CustomerId }, true);
        }
        else if(observer === "Streets"){
          me.refs.street.setState({ Data: me.StreetsModel.Streets, Icon :'' });
        } 
        else if(observer === "Gender"){
          let genderSelection = []
      
          if(this.GenderModel.Gender.length > 0){

            let genderArray = this.GenderModel.Gender;

            if(genderArray.length === 2) {
              genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] }];
            } else if(genderArray.length === 3){
              genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] },{ Key: genderArray[2], Display: 'divers' }];
            }
          }
          this.setState({GenderValues : genderSelection});
          this.refs.gender.setState({Data:genderSelection});
        }
      })
    }

    createAddresses(){
      if (this.checkFields() === true){

        this.AdditionalAddressesModel.Address.Street = this.AdditionalAddressesModel.Address.Street = "" ? $("#Street").val() : this.AdditionalAddressesModel.Address.Street;
        this.AdditionalAddressesModel.Address.HouseNumber = this.AdditionalAddressesModel.Address.HouseNumber = "" ? $("#HouseNumber").val() : this.AdditionalAddressesModel.Address.HouseNumber;

        ReactDOM.render(
          <ConfirmBox
          LabelConfirm={Vas.Resources.Titles["CreateAddress"]}
          LabelCancel={Vas.Resources.Labels["Cancel"]}
          MessageText={Vas.Resources.Labels["CreateAddAdressHint"] + " " + Vas.Resources.Labels["ConfirmHint"]}
          Click={()=>{
            this.AdditionalAddressesModel.SetNewAdditionalAddressByCustomerId(this.CustomerId);
          }}
          />,
          document.getElementById("messageContainer"));
      }
    }

    close(){
      Vas.GetView("CustomerCard",{Id:this.CustomerId},true);
    }

    checkFields(){
        let count;

        if (this.state.requiredFields && this.state.requiredSelectField ){
            count=this.state.requiredFields.length + this.state.requiredSelectField.length;
        }
        if (this.state.requiredFields && this.state.requiredSelectField){
            let filled=0;

            for (let i=0;i<this.state.requiredFields.length;i++){
                if (this.state.requiredFields[i]){
                    if (document.getElementById(this.state.requiredFields[i].props.Id).value.length>0){
                            filled++;
                    }
                }
            }
              
            for (let k = 0; k < this.state.requiredSelectField.length;k++){
              if (this.state.requiredSelectField[k]){
                  if (document.getElementById(this.state.requiredSelectField[k].props.Id).selectedIndex > 0){
                      filled++;
                  } 
              }
          }
            if (filled < count){
              let docs = document.querySelectorAll('select,input');
              let docRefs = this.refs;
              CheckValues.checkAllFields(docs,docRefs,"");
              ReactDOM.render(<MessageBox 
                Message={Vas.Resources.Labels["NotAllFields"]} 
                Title={Vas.Resources.Titles["Note"]}
                />
                  ,document.getElementById('messageContainer'));
               return false;
            } else {
               return true;
            }
        }
    }

    Close(){
        ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        $("#Content").css("opacity", "1");
    }

    checkSalutation(){
      if ($("#Salutation").val() === "Firma" || $("#Salutation").val() === "Schule") {
        let me = this;
        me.setState({ requiredFields:[me.refs.name,me.refs.zip, me.refs.city,me.refs.street,me.refs.houseNumber]},()=>{
              for (let i=0; i<me.state.requiredFields.length; i++){
                  if (me.state.requiredFields[i].props.IsRequired){
                    me.state.requiredFields[i].setState({ Label:me.state.requiredFields[i].props.Label+"*" });
                  }
              }
              me.refs.firstName.setState({Label:me.refs.firstName.props.Label});
          }
        ); 
      } else {
        let me = this;
        me.setState({ requiredFields:[me.refs.name,me.refs.firstName,me.refs.zip, me.refs.city,me.refs.street,me.refs.houseNumber,me.refs.dateOfBirth],
          requiredSelectField : me.refs.gender},()=>{
              for (let i=0; i<me.state.requiredFields.length; i++){
                  if (me.state.requiredFields[i].props.IsRequired){
                    me.state.requiredFields[i].setState({ Label:me.state.requiredFields[i].props.Label+"*" });
                  }
              }
          }
        ); 
      }
    }

    getStreets(){
      if(this.AdditionalAddressesModel.Address.Zip.length > 0 && this.AdditionalAddressesModel.Address.City.length > 0){
        this.StreetsModel.GetStreets(this.AdditionalAddressesModel.Address.City,this.AdditionalAddressesModel.Address.Zip);
      }
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){
        $('#AddressTypes').attr('style', 'border-bottom: 1px dotted #1d5c87;');
        $('.CreateAdditionalAddressForm #btoCreateAAddress').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
        $('.CreateAdditionalAddressForm #Cancel').attr('style', 'background-color: #1d5c87; width: 170px; float: right;');
        $('.CreateAdditionalAddressForm .textfield').attr('style', 'width: 170px; border-bottom: 1px dotted #1d5c87;');
        $('.CreateAdditionalAddressForm #Street').attr('style', 'width: 375px; border-bottom: 1px dotted #1d5c87;');
      }
    }

    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');
      var kontrastNumber = localStorage.getItem('Kontrast');

      //Schriftgröße bei Klick in 2er Schritten erhöhen

        if(schriftgröße != null){
            
              switch(schriftgröße){
                case "0":
                      $("#root").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".footer").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_32").addClass("Schriftgröße_33");
    
                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $('#tabContent').removeClass("TabContentPaddingLeft80").addClass("TabContentPaddingLeft100");
                      $('#btoChoose').removeClass("btoChooseWidth120_80").addClass("btoChooseWidth140_100");
                      $('.ItemData').removeClass("ItemDataWidth250").addClass("ItemDataWidth270");
                      $('.ItemContracts').removeClass('width160').addClass('width160');
                      $('.ItemNewContract').removeClass('width230').addClass('width240');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL45").addClass("tableHeaderPaddingL55");
                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL10").addClass("tableHeaderPaddingL25");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_26").addClass("Schriftgröße_28");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('.StepperLabel').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#From, #To').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('.termsOfUsage').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#btoChooseDocument').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#Payment_ButtonBack').removeClass('marginTop_20').addClass('marginTop_25');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR').addClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      if(kontrastNumber == "true"){
                        $('#btoCreateAAddress').attr('style', 'width: 394px; float: left; background-color: #1d5c87;');
                        $('#Cancel').attr('style', 'width: 394px; float: right; background-color: #1d5c87;');
                      } else {
                        $('#btoCreateAAddress').attr('style', 'width: 394px; float: left;');
                        $('#Cancel').attr('style', 'width: 394px; float: right;');
                      }
                break;
                case "1":

                      $("#root").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".footer").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_33").addClass("Schriftgröße_28");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $('#tabContent').removeClass("TabContentPaddingLeft100").addClass("TabContentPaddingLeft1");
                      $('#btoChoose').removeClass("btoChooseWidth140_100").addClass("btoChooseWidth100_0");
                      $('.ItemData').removeClass("ItemDataWidth270").addClass("ItemDataWidth190");
                      $('.ItemContracts').removeClass('width160').addClass('width110');
                      $('.ItemNewContract').removeClass('width240').addClass('width210');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                      $('html body div#root.Schriftgröße_16 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft1 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                      $('html body div#root.Schriftgröße_16 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft1 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL55").addClass("tableHeaderPaddingL25");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_28").addClass("Schriftgröße_18");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('.StepperLabel').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('#From, #To').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('.termsOfUsage').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#btoChooseDocument').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#Payment_ButtonBack').removeClass('marginTop_25');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1102").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_17").addClass("Schriftgröße_12");

                break;
                case "2":
                      $("#root").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".footer").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_28").addClass("Schriftgröße_29");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#tabContent').removeClass("TabContentPaddingLeft1").addClass("TabContentPaddingLeft20");
                      $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_20");
                      $('.ItemData').removeClass("ItemDataWidth190").addClass("ItemDataWidth210");
                      $('.customerCardSubTitle').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_18").addClass("Schriftgröße_20");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('.StepperLabel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('#From, #To').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('.termsOfUsage').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('#btoChooseDocument').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#Payment_ButtonBack').addClass('marginTop_5');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_14").addClass("Schriftgröße_15").addClass("downloadCsvPadding_1106");

                      $('.ItemContracts').removeClass('width110').addClass('width120');

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_12").addClass("Schriftgröße_13");

                break;
                case "3":
                      $("#root").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".footer").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_5").addClass("Schriftgröße_16");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_29").addClass("Schriftgröße_30");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#tabContent').removeClass("TabContentPaddingLeft20").addClass("TabContentPaddingLeft40");
                      $('#btoChoose').removeClass("btoChooseWidth100_20").addClass("btoChooseWidth100_40");
                      $('.ItemData').removeClass("ItemDataWidth210").addClass("ItemDataWidth210");
                      $('.ItemContracts').removeClass('width120').addClass('width140');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                      $('html body div#root.Schriftgröße_18 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft40 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL25").addClass("tableHeaderPaddingL45");
                      $('html body div#root.Schriftgröße_18 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft40 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL25").addClass("tableHeaderPaddingL10");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_20").addClass("Schriftgröße_22");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('.StepperLabel').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#From, #To').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('.termsOfUsage').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#btoChooseDocument').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#Payment_ButtonBack').removeClass('marginTop_5').addClass('marginTop_10');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_13").addClass("Schriftgröße_14");
                break;
                case "4":
                      $("#root").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".footer").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_30").addClass("Schriftgröße_31");
    
                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#tabContent').removeClass("TabContentPaddingLeft40").addClass("TabContentPaddingLeft60");
                      $('#btoChoose').removeClass("btoChooseWidth100_40").addClass("btoChooseWidth100_60");
                      $('.ItemData').removeClass("ItemDataWidth210").addClass("ItemDataWidth230");
                      $('.ItemContracts').removeClass('width140').addClass('width140');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_22").addClass("Schriftgröße_24");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('.StepperLabel').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('#From, #To').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('.termsOfUsage').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('#btoChooseDocument').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#Payment_ButtonBack').removeClass('marginTop_10').addClass('marginTop_15');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1106").removeClass("Schriftgröße_16").addClass("Schriftgröße_17").addClass("downloadCsvPadding_1104");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').addClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                break;
                case "5":
                  $("#root").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".footer").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_31").addClass("Schriftgröße_32");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $('#tabContent').removeClass("TabContentPaddingLeft60").addClass("TabContentPaddingLeft80");
                      $('#btoChoose').removeClass("btoChooseWidth100_60").addClass("btoChooseWidth120_80");
                      $('.ItemData').removeClass("ItemDataWidth230").addClass("ItemDataWidth250");
                      $('.ItemContracts').removeClass('width140').addClass('width160');
                      $('.ItemNewContract').removeClass('width210').addClass('width230');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_24").addClass("Schriftgröße_26");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('.StepperLabel').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('#From, #To').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('.termsOfUsage').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('#btoChooseDocument').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#Payment_ButtonBack').removeClass('marginTop_15').addClass('marginTop_20');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1104").removeClass("Schriftgröße_17").addClass("Schriftgröße_18").addClass("downloadCsvPadding_1102");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR').addClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      if(kontrastNumber == "true"){
                        $('#btoCreateAAddress').attr('style', 'width: 394px; float: left; background-color: #1d5c87;');
                        $('#Cancel').attr('style', 'width: 394px; float: right; background-color: #1d5c87;');
                      } else {
                        $('#btoCreateAAddress').attr('style', 'width: 394px; float: left;');
                        $('#Cancel').attr('style', 'width: 394px; float: right;');
                      }
                break;
              }
        }
    }

    render(){
       
    return (
      <div id={"CreateAdditionalAddressForm"}>
        <div className={"CreateAdditionalAddressForm"}>

            <div>
              <h2 id={"CreateAdditionalAddressHeadline"}>{Vas.Resources.Titles["CreateAddress"]}</h2>
            </div>

            <div className={"Container"}>
              <div>{this.state.CustomerText}<br /><br /></div>
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeftAddressType"}>
              <SelectField 
                AppURL={Vas.ApplicationUrl} 
                Id={"AddressTypes"}
                IsRequired={true}
                Label={Vas.Resources.Labels["AddressTyp"]}
                OnChange={()=>{this.AdditionalAddressesModel.Address.AddressType.Id = $("#AddressTypes").val() ;}}
                ref={"addressTypes"}
                //LabelHeight={'14px'}
            />
              </div>
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeftHint"} style={{ textAlign:'left', fontSize:'12px'}}>
                <b>{Vas.Resources.Titles["Note"]}: </b>
                <i>{Vas.Resources.Labels["CreateAddAdressHint"]}</i>
              </div>
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeft"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                ref={"name"}
                Editable={true}
                IsRequired={true}
                Id={"Name1"}
                Label={Vas.Resources.Labels["Name"]}
                OnBlur={()=>{ this.AdditionalAddressesModel.Address.Name1 =  $("#Name1").val() ; }} /></div>
              <div className={"ContainerRight"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                ref={"firstName"}
                Editable={true}
                IsRequired={true}
                Id={"Name2"}
                Label={Vas.Resources.Labels["FirstName"]}
                OnBlur={()=>{ this.AdditionalAddressesModel.Address.Name2 = $("#Name2").val() ; }} /></div>
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeft"}>
                <SelectField 
                AppURL={Vas.ApplicationUrl} 
                Data={ this.state.GenderValues }
                Id={"Gender"}
                IsRequired={true}
                Label={Vas.Resources.Labels["Gender"]}
                OnChange={()=>{this.AdditionalAddressesModel.Address.Gender= TranslateGender.Translate($("#Gender").val(),localStorage.getItem('vas_language')) ;}}
                ref={"gender"}
                Tooltip={Vas.Resources.Tooltips["Gender"]}
                LabelHeight={'14px'}
            /></div>
              <div className={"ContainerRight"}>
                <DateField 
                AppURL={Vas.ApplicationUrl}
                Editable={true}
                FalseDateText={Vas.Resources.Labels["DateNotValid"]}
                FalseDateTitle={Vas.Resources.Titles["Note"]}
                Id={"DateOfBirth"}
                IsRequired={true}
                Label={Vas.Resources.Labels["DateOfBirth"]}
                Language={localStorage.getItem("vas_language")}
                MaxValue={moment([moment().year() - 18, moment().month(), moment().date() + 1])}
                OnBlur={()=>{
                  let curDateOfBirthAddresses = DateTimeHelper.StringToDate($("#DateOfBirth").val() ,false,localStorage.getItem('vas_language'));
                  this.AdditionalAddressesModel.Address.DateOfBirth = moment([curDateOfBirthAddresses.year(),curDateOfBirthAddresses.month(),curDateOfBirthAddresses.date()]).format('YYYY-MM-DD T 00:00:00');
                }}
                ref={"dateOfBirth"}
                Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]}
                FalseMinDateText={Vas.Resources.Labels["InvalidDateOfBirth"]}/>
              </div>
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeft"}><TextField
                AppURL={Vas.ApplicationUrl}
                ref={"zip"}
                Editable={true}
                Id={"Zip"}
                IsRequired={true}
                Label={Vas.Resources.Labels["Zip"]}
                OnBlur={()=>{ 
                  if ($("#Zip").val().length === 5){
                    this.AdditionalAddressesModel.Address.Zip= $("#Zip").val() ; this.getStreets(); 
                  } else {
                    $("#Zip").val('');
                    ReactDOM.render(<MessageBox 
                      Message={Vas.Resources.Labels["PLZNote"]} 
                      Title={Vas.Resources.Titles["Note"]} />
                        ,document.getElementById('messageContainer'));
                  }
                }}
                   /></div>
              <div className={"ContainerRight"}><TextField
                AppURL={Vas.ApplicationUrl}
                ref={"city"}
                Editable={true}
                Id={"City"}
                IsRequired={true}
                Label={Vas.Resources.Labels["Place"]}
                OnBlur={()=>{ this.AdditionalAddressesModel.Address.City = $("#City").val() ; this.getStreets();}} /> </div>
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeftStreet"}>
                <AutocompleteField
                  AppURL={Vas.ApplicationUrl}
                  TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                  MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}
                  me={this}
                  Width={375}
                  Modus={"Street"}
                  IsRequired={true}
                  ref={"street"}
                  Id={"Street"}
                  Float={'left'}
                  editable={true}
                  Label={Vas.Resources.Labels["Street"]}
                  Data={this.state.streets}
                  OnBlur={()=>{this.AdditionalAddressesModel.Address.Street= $("#Street").val() ;}}
                  Tooltip={Vas.Resources.Tooltips["Street"]}
                  TimeOutTime={Vas.TimeOutTime} />
              </div>
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeft"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                ref={"houseNumber"}
                Editable={true}
                IsRequired={true}
                Id={"HouseNumber"}
                Label={Vas.Resources.Labels["HouseNumber"]}
                OnBlur={()=>{ this.AdditionalAddressesModel.Address.HouseNumber = $("#HouseNumber").val() ; }} />
              </div>
              <div className={"ContainerRight"}><TextField
                AppURL={Vas.ApplicationUrl}
                ref={"houseNumberAddition"}
                Editable={true}
                IsRequired={false}
                Id={"HouseNumberAddition"}
                Label={Vas.Resources.Labels["HouseNumberAddition"]}
                OnBlur={()=>{ this.AdditionalAddressesModel.Address.HouseNumberAddition = $("#HouseNumberAddition").val() ; }} />
              </div>
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeftAdditionalAddress"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                ref={"name3"}
                Width={375}
                Editable={true}
                Id={"Name3"}
                IsRequired={false}
                Label={Vas.Resources.Labels["AdditionAdress"]}
                OnBlur={()=>{ this.AdditionalAddressesModel.Address.Name3= $("#Name3").val() ; }} /></div>
            </div>
            
            <div className={"Container"}>
              <div className={"ContainerLeftPhone"}><TextField
                AppURL={Vas.ApplicationUrl}
                ref={"phone"}
                Editable={true}
                IsRequired={false}
                Id={"Phone"}
                Label={Vas.Resources.Labels["Phone"]}
                OnBlur={()=>{ this.AdditionalAddressesModel.Address.Phone = $("#Phone").val() ; }} /></div>            
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeftEmail"}>
                <EmailField
                  ApiUrl={Vas.ApiUrl}
                  ApiKey={Vas.ApiKey}
                  Token={localStorage.getItem["vas_token"]}
                  AnonymousToken={localStorage.getItem["anonymous_token"]}
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Id="Email"
                  ref={"email"}
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Email"]}
                  Label={Vas.Resources.Labels["Email"]}
                  OnBlur={()=>{
                    if (this.refs.email.getValid() === true){
                      this.AdditionalAddressesModel.Address.Email = $("#Email").val();
                    } else {
                      $('#Email').val('');
                      this.AdditionalAddressesModel.Address.Email = '' ;
                    }
                  }} 
                  Width={340}/>
              </div>
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeftValidFrom"}>
                <DateField 
                AppURL={Vas.ApplicationUrl}
                Editable={true}
                FalseDateText={Vas.Resources.Labels["DateNotValid"]}
                FalseDateTitle={Vas.Resources.Titles["Note"]}
                Id={"ValidFrom"}
                IsRequired={false}
                Label={Vas.Resources.Labels["ValidFrom"]}
                Language={localStorage.getItem("vas_language")}
                MinValue={moment()}
                OnBlur={()=>{
                  let curValidFrom = moment();
                  if ($("#ValidFrom").val()){
                    curValidFrom = DateTimeHelper.StringToDate($("#ValidFrom").val(),false,localStorage.getItem('vas_language'));
                  }
                  this.AdditionalAddressesModel.Address.ValidFrom = moment([curValidFrom.year(),curValidFrom.month(),curValidFrom.date()]).format('YYYY-MM-DD T 00:00:00');
                }}
                ref={"validFrom"}
                FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]}
                FalseMinDateText={Vas.Resources.Labels["InvalidDateOfBirth"]}
              /></div>
              
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeftHint"} style={{ textAlign:'left', fontSize:'12px', paddingTop: '60px' }}>
                <b>{Vas.Resources.Titles["Note"]}: </b>
                <i>{Vas.Resources.Labels["NoteDateAddresses"]}</i>
              </div>
            </div>
            <div className={"Container"} style={{ paddingTop: '60px' }}>
              <div className={"ContainerLeft"}><br /><div style={{ float:'left' }}>{Vas.Resources.Labels["RequiredField"]}</div></div>
            </div>
            <div className={"Container"}>
              <div className={"ContainerLeft"} style={{float:"none", paddingTop:"20px"}}><br />
              <div >
                <ExtendedButton
                Id={"btoCreateAAddress"}
                ref={"Create"}
                Text={Vas.Resources.Labels["Add"]}
                Float={'left'}
                Width={170}
                OnClick={()=>{ this.createAddresses();}} 
                Usable={true}/>
              </div>
                
              </div>
              <div id={"additionalAddressCancel"} className={"ContainerRight"} style={{marginTop:"-20px"}}><br />
                <ExtendedButton
                  ref={"Cancel"}
                  Usable={true}
                  Text={Vas.Resources.Labels["Cancel"]}
                  Float={'left'}
                  OnClick={()=>{this.close();}}
                  Id={"Cancel"}
                  Width={170}/>
              </div>
            </div>
        </div>
      </div>       
        );
    }
}
export default CreateAdditionalAddress;
